<template>
  <menu-table v-if="hasInterview" :patient_id="patient_id"/>
  <v-container fluid grid-list-md v-else>
    <v-layout justify-center>
      <v-flex xs12 sm12 md12 d-flex>
        <p class="text-center"
           v-html="trans('app.interview.missing_interview', {'url':'/patients/'+patient_id+'/interview'})">
        </p>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  props: {
    patient_id: {
      type: Number,
    }
  },
  computed: {
    ...mapGetters(['hasInterview']),
  },
}
</script>
